import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato recibo el bundle?',
  a: 'Todo es digital en formato PDF de alta resolución (300 DPI para impresión). Accedés inmediatamente después del pago a través del link de descarga. Podés imprimirlo o usarlo en pantalla.'
}, {
  q: '¿Necesito experiencia previa en craft?',
  a: 'No. El Tomo 1 empieza desde cero absoluto. Si ya tenés experiencia, podés ir directamente al tomo que necesitás. Los 6 tomos están diseñados para avanzar en progresión.'
}, {
  q: '¿Sirve si estoy en México, Colombia o Chile?',
  a: 'Sí. El bundle está pensado para toda Latinoamérica. Las medidas están en centímetros, el Bono de Proveedores incluye referencias para múltiples países y el contenido no depende de marcas específicas.'
}, {
  q: '¿Puedo usarlo para dar talleres?',
  a: 'El bundle tiene licencia de uso personal y educativo. Podés usarlo como base para tus talleres. Lo que no podés es revender, distribuir ni copiar el contenido directamente.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Si dentro de los 7 días desde la compra sentís que el bundle no cumplió lo que prometía, escribinos y te devolvemos el 100% del dinero. Sin preguntas, sin procesos complicados.'
}, {
  q: '¿Qué diferencia tiene este bundle de un curso en video?',
  a: 'Este es un sistema en PDF de alta calidad con más de 910 páginas de contenido técnico, plantillas milimétricas, diagramas y checklists. No tiene videos. La ventaja: lo tenés para siempre, podés imprimir lo que necesitás y trabajar a tu ritmo sin depender de una plataforma.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border border-brand-line rounded-xl overflow-hidden" data-id="element-11">
      <button onClick={() => setOpen(!open)} aria-expanded={open} className="w-full flex items-center justify-between gap-3 sm:gap-4 p-5 sm:p-6 text-left bg-brand-paper hover:bg-brand-cream transition-colors" data-id="element-12">
        <span className="font-bold text-brand-ink text-sm sm:text-base" data-id="element-13">
          {q}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-gold shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-14" />
      </button>
      {open && <div className="px-5 sm:px-6 pb-5 sm:pb-6 bg-brand-cream" data-id="element-15">
          <p className="text-brand-muted leading-relaxed text-sm" data-id="element-16">{a}</p>
        </div>}
    </div>;
}
export function FAQ() {
  return <section id="faq" className="py-16 sm:py-24 px-5 bg-brand-cream" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <FadeIn className="text-center mb-12 sm:mb-14" data-id="element-19">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-20">
            Preguntas frecuentes
          </span>
          <h3 className="text-3xl sm:text-5xl font-black text-brand-ink mt-4" data-id="element-21">
            Todo lo que querés
            <br data-id="element-22" />
            saber antes de comprar.
          </h3>
        </FadeIn>

        <FadeIn delay={0.1} className="space-y-3" data-id="element-23">
          {faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} data-id="element-24" />)}
        </FadeIn>

        <FadeIn delay={0.2} className="mt-12 text-center" data-id="element-25">
          <p className="text-brand-muted mb-6" data-id="element-26">¿Todavía tenés dudas?</p>
          <a href="#oferta" className="inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-goldHover text-white font-bold px-8 py-4 rounded-xl transition-all hover:-translate-y-0.5 shadow-[0_8px_20px_rgba(184,137,79,0.3)]" data-id="element-27">
            Ver la oferta completa →
          </a>
        </FadeIn>
      </div>
    </section>;
}